export function initCitySelect() {
  const $citySelect = $('.city-select');
  if (!$citySelect || $citySelect.length === 0) return;
  const placeholder = $citySelect.data('placeholder');
  const width = $citySelect.data('width');
  let autoWidth = false;
  if (width === 'auto') autoWidth = true;

  $.getJSON('/assets/json/cities.json', (data) => {
    $citySelect.select2({
      selectionCssClass: ':all:',
      dropdownCssClass: ':all:',
      placeholder: placeholder,
      dropdownAutoWidth: autoWidth,
      tags: true,
      createTag: function (params) {
        return {
          id: params.term,
          text: params.term,
          newOption: true,
        };
      },
      templateResult: function (data) {
        const $result = $('<span></span>');

        $result.text(data.text);

        if (data.newOption) {
          $result.append(' <em>(new)</em>');
        }

        return $result;
      },
      data: data,
    });
  });
}
